export enum AgentHeaderKeys {
  primaryEmailAddress = 'primaryEmailAddress',
  primaryPhoneNumber = 'primaryPhoneNumber',
  primaryShippingAddress = 'primaryShippingAddress',
  primaryBillingAddress = 'primaryBillingAddress',
}
